module.exports = __webpack_public_path__ + "img/weixin.ceba62f4.svg";